"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handle = void 0;
exports.handle = (promise) => promise
    .then((data) => [undefined, data])
    .catch((error) => Promise.resolve([
    error.message === "[object Object]" ? {} : error,
    undefined,
]));
exports.default = exports.handle;
